import Button from 'emerald-ui/lib/Button';
import Dropdown from 'emerald-ui/lib/Dropdown';
import FloatingActionButton from 'emerald-ui/lib/FloatingActionButton';
import populateDocs from './utils/populateDocs';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: Dropdown, componentName: 'Dropdown' }], 'Dropdown'),
  description: 'An overlay for displaying lists of items.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Button, Dropdown },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<Dropdown>
  <Button>
    Actions
    <span className="caret" />
  </Button>
  <Dropdown.Menu>
    <Dropdown.Item>Action</Dropdown.Item>
    <Dropdown.Item>Another action</Dropdown.Item>
    <Dropdown.Item separator />
    <Dropdown.Item color="danger">Dangerous action</Dropdown.Item>
    <Dropdown.Item disabled tooltip="This is why I'm disabled">
      Can't touch this
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>`,
    },
    {
      title: 'With FloatingActionButton',
      scope: { Dropdown, FloatingActionButton },
      whiteBackground: true,
      code: `<Dropdown>
  <FloatingActionButton icon="add" />
  <Dropdown.Menu
    style={{
      marginTop: '13px',
      transformOrigin: 'top center',
      left: '-72px'
    }}
  >
    <Dropdown.Item header>Bulk upload type</Dropdown.Item>
    <Dropdown.Item>Applicants</Dropdown.Item>
    <Dropdown.Item>Employees</Dropdown.Item>
    <Dropdown.Item>Providers</Dropdown.Item>
    <Dropdown.Item>Course completions</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>`,
    },
  ],
};
